// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_k7-0";